// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__jfwMZ","SocialNetwor":"Footer_SocialNetwor__HtOnv","mid-footer":"Footer_mid-footer__xy3pW"};